import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'

// const Login = () => import('../views/login/login.vue')
const Main = () => import('../views/app/main.vue')
const Dashboard = () => import('../views/app/dashboard.vue')
const DashboardActual = () => import('../views/app/dashboard/actual.vue')
const DashboardCommonPage = () =>
  import('../views/app/dashboard/actual-tasks/common-page.vue')
const DashboardMonthPage = () =>
  import('../views/app/dashboard/actual-tasks/month-page.vue')
const DashboardWeekPage = () =>
  import('../views/app/dashboard/actual-tasks/week-page.vue')
const DashboardHistory = () => import('../views/app/dashboard/history.vue')
const Contracts = () => import('../views/app/contracts.vue')
const ContractsAll = () => import('../views/app/contracts/contracts-all.vue')
const ContractsEdit = () => import('../views/app/contracts/contracts-edit.vue')
const Contract = () => import('../views/app/contract/contract.vue')
const ContractOverview = () => import('../views/app/contract/overview.vue')
const ContractTimeTable = () => import('../views/app/contract/time-table.vue')
const ContractRegister = () => import('../views/app/contract/register.vue')
const ContractAmendments = () => import('../views/app/contract/amendments.vue')
const ContractContragents = () =>
  import('../views/app/contract/contragents.vue')
const ContractActs = () => import('../views/app/contract/acts.vue')
const ContractPayments = () => import('../views/app/contract/payments.vue')
const ContractLawCases = () => import('../views/app/contract/law-cases.vue')
const ContractConclusions = () => import('../views/app/contract/conclusions.vue')
const ContractExpertises = () => import('../views/app/contract/expertises.vue')
const ContractResources = () => import('../views/app/contract/resources.vue')
const ContractBgs = () => import('../views/app/contract/bgs.vue')
const Contragents = () => import('../views/app/contragents.vue')
const ContragentsEdit = () =>
  import('../views/app/contragents/contragents-edit.vue')
const Contragent = () => import('../views/app/contragent/contragent')
const ContragentOverview = () => import('../views/app/contragent/overview')
const ContragentAmendments = () => import('../views/app/contragent/amendments')
const ContragentActs = () => import('../views/app/contragent/acts')
const ContragentPayments = () => import('../views/app/contragent/payments.vue')
const ContragentResources = () =>
  import('../views/app/contragent/resources.vue')
const TimeTable = () => import('../views/app/time-table.vue')
const ContractsRegister = () => import('../views/app/contracts-register.vue')
const Experience = () => import('../views/app/experience.vue')
const Acts = () => import('../views/app/acts.vue')
const Payments = () => import('../views/app/payments.vue')
const Procedures = () => import('../views/app/procedures.vue')
const LawCases = () => import('../views/app/law-cases.vue')
const Reports = () => import('../views/app/reports.vue')
const Report = () => import('../views/app/reports/report.vue')
const Books = () => import('../views/app/books.vue')
const Profile = () => import('../views/app/profile.vue')

Vue.use(Router)

const isAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next()
    return
  }
  console.log('redirect to /saml/init from router')
  window.location.href = '/saml/init'
}

const hasModule = (module, path = '/app/contracts/all') => (to, from, next) => {
  if (store.getters.hasModule(module)) {
    return next()
  }

  next(path)
}
const hasContractModule = (module, type) => (to, from, next) => {
  if (store.getters.getContractModulePerms(module, type)) {
    return next()
  }

  next('/app/contracts/all')
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      name: 'all',
      path: '*',
      redirect: '/app/contracts'
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: Login
    // },
    {
      name: 'app',
      path: '/app',
      // beforeEnter: isAuthenticated,
      component: Main,
      redirect: '/app/contracts',
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: Dashboard,
          redirect: '/app/dashboard/actual',
          children: [
            {
              name: 'actual',
              path: 'actual',
              component: DashboardActual,
              redirect: '/app/dashboard/actual/common',
              children: [
                {
                  name: 'dashboard-common-page',
                  path: 'common',
                  component: DashboardCommonPage
                },
                {
                  name: 'dashboard-month-page',
                  path: 'month',
                  component: DashboardMonthPage
                },
                {
                  name: 'dashboard-week-page',
                  path: 'week',
                  component: DashboardWeekPage
                }
              ]
            },
            {
              name: 'history',
              path: 'history',
              component: DashboardHistory
            }
          ]
        },
        {
          name: 'contracts',
          path: 'contracts',
          component: Contracts,
          redirect: '/app/contracts/all',
          children: [
            {
              name: 'contracts-all',
              path: 'all',
              component: ContractsAll
            },
            {
              name: 'contracts-edit',
              path: 'edit',
              component: ContractsEdit,
              beforeEnter: hasContractModule('contract_info', 'create')
            },
            {
              name: 'contract',
              path: ':id',
              component: Contract,
              redirect: '/app/contracts/:id/overview',
              children: [
                {
                  name: 'contract-overview',
                  path: 'overview',
                  component: ContractOverview
                },
                {
                  name: 'contract-time-table',
                  path: 'time-table',
                  component: ContractTimeTable
                },
                {
                  name: 'contract-register',
                  path: 'register',
                  component: ContractRegister
                },
                {
                  name: 'contract-amendments',
                  path: 'amendments',
                  component: ContractAmendments,
                  beforeEnter: hasContractModule('amendments', 'read')
                },
                {
                  name: 'contract-contragents',
                  path: 'contragents',
                  component: ContractContragents,
                  beforeEnter: hasContractModule('contragents', 'read')
                },
                {
                  name: 'contract-acts',
                  path: 'acts',
                  component: ContractActs,
                  beforeEnter: hasContractModule('contract_acts', 'read')
                },
                {
                  name: 'contract-payments',
                  path: 'payments',
                  component: ContractPayments,
                  beforeEnter: hasContractModule('contract_payments', 'read')
                },
                {
                  name: 'contract-law-cases',
                  path: 'law-cases',
                  component: ContractLawCases,
                  beforeEnter: hasModule('law_cases')
                },
                {
                  name: 'contract-conclusions',
                  path: 'conclusions',
                  component: ContractConclusions,
                  beforeEnter: hasModule('procedure')
                },
                {
                  name: 'contract-expertises',
                  path: 'expertises',
                  component: ContractExpertises,
                  beforeEnter: hasModule('procedure')
                },
                {
                  name: 'contract-resources',
                  path: 'resources',
                  component: ContractResources
                },
                {
                  name: 'contract-bgs',
                  path: 'bgs',
                  component: ContractBgs
                }
              ]
            }
          ]
        },
        {
          name: 'contragents',
          path: 'contragents',
          component: Contragents,
          redirect: '/app/contracts/all',
          children: [
            {
              name: 'contragents-edit',
              path: 'edit',
              component: ContragentsEdit,
              beforeEnter: hasContractModule('contragents', 'create')
            },
            {
              name: 'contragent',
              path: ':id',
              component: Contragent,
              redirect: '/app/contragents/:id/overview',
              beforeEnter: hasContractModule('contragents', 'read'),
              children: [
                {
                  name: 'contragent-overview',
                  path: 'overview',
                  component: ContragentOverview
                },
                {
                  name: 'contragent-amendments',
                  path: 'amendments',
                  component: ContragentAmendments,
                  beforeEnter: hasContractModule('amendments', 'read')
                },
                {
                  name: 'contragent-acts',
                  path: 'acts',
                  component: ContragentActs,
                  beforeEnter: hasContractModule('contragent_acts', 'read')
                },
                {
                  name: 'contragent-payments',
                  path: 'payments',
                  component: ContragentPayments,
                  beforeEnter: hasContractModule('contragent_payments', 'read')
                },
                {
                  name: 'contragent-resources',
                  path: 'resources',
                  component: ContragentResources
                }
              ]
            }
          ]
        },
        {
          name: 'time-table',
          path: 'time-table',
          component: TimeTable,
          beforeEnter: hasModule('time-table'),
          children: []
        },
        {
          name: 'contracts-register',
          path: 'contracts-register',
          component: ContractsRegister,
          beforeEnter: hasModule('contract_register'),
          children: []
        },
        {
          name: 'experience',
          path: 'experience',
          component: Experience,
          beforeEnter: hasModule('experience'),
          children: []
        },
        {
          name: 'acts',
          path: 'acts',
          component: Acts,
          beforeEnter: hasModule('contract_acts'),
          children: []
        },
        {
          name: 'payments',
          path: 'payments',
          component: Payments,
          beforeEnter: hasModule('contract_payments'),
          children: []
        },
        {
          name: 'procedures',
          path: 'procedures',
          component: Procedures,
          beforeEnter: hasModule('procedure'),
          children: []
        },
        {
          name: 'law-cases',
          path: 'law-cases',
          component: LawCases,
          beforeEnter: hasModule('law_cases'),
          children: []
        },
        {
          name: 'reports',
          path: 'reports',
          component: Reports,
          beforeEnter: hasModule('reports'),
          redirect: '/app/reports/new_report_2',
          children: [
            {
              name: 'report',
              path: ':id',
              component: Report
            }
          ]
        },
        {
          name: 'books',
          path: 'books',
          component: Books,
          beforeEnter: hasModule('books'),
          children: []
        },
        {
          name: 'profile',
          path: 'profile',
          component: Profile
        }
      ]
    }
  ]
})
